// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/musterentwicklung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const musterentwicklungDE: PageEntry = {
  id: "post.musterentwicklung",
  locale: "de",
  slug: "musterentwicklung",
  seo: {
    title: "Glossar: Musterentwicklung einfach erklärt | Dietz GmbH",
    description: "Musterentwicklung beschreibt den fortgeschrittenen Prozess, bei dem Musterdesigns in greifbare Prototypen oder Modelle umgesetzt werden. Dieser Schritt erfolgt nach der Gestaltung ",
  },
  type: "post",
  h1: "Glossar: Musterentwicklung einfach erklärt",
  intro: "Musterentwicklung beschreibt den fortgeschrittenen Prozess, bei dem Musterdesigns in greifbare Prototypen oder Modelle umgesetzt werden. Dieser Schritt erfolgt nach der Gestaltung von Musterentwürfen und ist entscheidend, um die Machbarkeit, Funktionalität und Ästhetik des Designs zu überprüfen. In verschiedenen Branchen, von der Mode bis zur Produktentwicklung, spielt die Musterentwicklung eine zentrale Rolle bei der Umsetzung von Ideen in physische Modelle, die als Grundlage für die Mustererstellung und -konstruktion dienen.",
  blocks: [

  ],
};
